import { Store } from "react-notifications-component";
import { translateMessage } from "./messageTranslations";

const TYPE_MAP = {
  info: "info",
  success: "success",
  warning: "warning",
  danger: "danger",
  error: "danger",
};

const mapType = (type) => TYPE_MAP[type] || "default";

const DISMISS_MS = 3000;

export function notify(type, title, message) {
  const id = Store.addNotification({
    title: translateMessage(title),
    message: translateMessage(message),
    type: mapType(type),
    insert: "top",
    container: "bottom-right",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: { duration: DISMISS_MS, click: true },
  });

  // Fallback removal: react-notifications-component only starts its auto-dismiss
  // timer on the enter transition's `transitionend`, which never fires if global
  // CSS overrides the transition, leaving toasts stuck on screen. Removing by id
  // after the duration guarantees the toast goes away regardless.
  if (id) {
    setTimeout(() => Store.removeNotification(id), DISMISS_MS + 500);
  }
}
